import { twMerge } from 'tailwind-merge';

export const getButtonTextStyle = (current: boolean) =>
  twMerge(
    'group text-c-card-muted hover:text-c-card-foreground hover:bg-c-background w-24 flex-col gap-y-1.5 py-2.5 whitespace-normal transition-all duration-300 ease-in-out dark:hover:bg-gray-900',
    current ? 'text-c-card-foreground bg-c-background dark:bg-gray-900' : 'bg-transparent'
  );

export const getButtonIconStyle = (current: boolean) =>
  twMerge('text-c-card-muted group-hover:text-c-card-foreground m-0', current && 'text-c-card-foreground');
